// @flow
import md5 from 'crypto-js/md5';
import {CENTRIFUGE_ACTION_TYPES} from 'modules/centrifuge/constants';
import type {TActionConnectionInProcess, TActionSetConnectionData, TActionSetIsConnected} from 'modules/centrifuge/reducers';
import {selectConnectionData, selectConnectionInProcess, selectIsConnected} from 'modules/centrifuge/selectors';
import type {TResponse, TThunkAction} from 'types';
/**
 * экшн для установки значения подключения
 * @param payload булево значение
 * @return значение подключена ли центрифуга
 */
function actionSetIsConnected(payload: boolean): TActionSetIsConnected {
    return {
        payload,
        type: CENTRIFUGE_ACTION_TYPES.CENTRIFUGE_SET_IS_CONNECTED,
    };
}
/**
 * экшн для установки данных для подключения центрифуги
 * @param payload булево значение
 * @return данные для подключения центрифуги
 */
function actionSetConnectionData(payload: boolean): TActionSetConnectionData {
    return {
        payload,
        type: CENTRIFUGE_ACTION_TYPES.CENTRIFUGE_SET_CONNECTION_DATA,
    };
}

/**
 * экшн для установки значения подключения
 * @param payload булево значение
 * @return значение в процессе ли подключения центрифуга
 */
function setConnectionInProcess(payload: boolean): TActionConnectionInProcess {
    return {
        payload,
        type: CENTRIFUGE_ACTION_TYPES.CENTRIFUGE_SET_IN_PROGRESS,
    };
}

/**
 * функция подключения к центрифуге
 * @return ThunkAction
 */
function connectCentrifuge() {
    return async (dispatch, getState, {centrifugeService, centrifugeApi}) => {
        dispatch(setConnectionInProcess(true));
        const response = await centrifugeApi.getConnectionData();
        if (response.success) {
            // await fetch(response.data.url);
            await dispatch(actionSetConnectionData(response.data));
        }

        const connectionData = selectConnectionData(getState());
        if (connectionData) {
            centrifugeService.connect({
                connectionData,
                onConnect: () => {
                    dispatch(actionSetIsConnected(false));
                    dispatch(setConnectionInProcess(true));
                },
                onDisconnect: () => {
                    dispatch(actionSetIsConnected(false));
                },
            });
        }
    };
}

/**
 * подписка на канал уведомлений
 * @return null
 */
export function subscribeNotificationChannel(): TThunkAction<TResponse<null>> {
    return async (dispatch, getState, {centrifugeService}) => {
        const connectionData = selectConnectionData(getState());
        if (connectionData && connectionData.user) {
            const channelName = md5(connectionData.user).toString();
            centrifugeService.subscribeChannel(channelName, () => {
                // console.log(data);
            });
        }
        return {data: null, success: true};
    };
}
/**
 * Создание подключения центрифуги
 * @return ThunkAction
 */
export function initCentrifuge(): TThunkAction<TResponse<null>> {
    return async (dispatch, getState) => {
        const state = getState();
        const isConnected = selectIsConnected(state);
        const inProcess = selectConnectionInProcess(state);

        if (!isConnected && !inProcess) {
            await dispatch(connectCentrifuge());
        }
        return {data: null, success: true};
    };
}
